module.exports = __webpack_public_path__ + "assets/ba0ccd9922c114f7ede9f262cc4373ed.png";